module.exports = __webpack_public_path__ + "static/media/platform-llm.667c5d75.webp";